import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { StackingOptions } from '../../../core/types';
import { Message, MessageService } from '../../../core/services/message.service';

@Component({
    selector: 'gl-load-arrangement',
    templateUrl: './load-arrangement.component.html',
    styleUrls: ['./load-arrangement.component.scss'],
    standalone: false
})
export class LoadArrangementComponent implements OnInit, OnDestroy, OnChanges {
  public loadArrangementForm: UntypedFormGroup;
  @Input() public stackingOptions: StackingOptions;
  @Input() public currentType = 1;
  @Input() public isListEdit = false;
  @Output() public loadArrangementChange = new EventEmitter<number>();
  private messageSubscription: Subscription;

  constructor(private messageService: MessageService, private cdr: ChangeDetectorRef) {}

  private createForm(): void {
    const isStraight: boolean = this.stackingOptions?.formation === 1;
    const isHoneycomb: boolean = this.stackingOptions?.formation === 2;
    this.loadArrangementForm = new UntypedFormGroup({
      straight: new UntypedFormControl(isStraight),
      honeycomb: new UntypedFormControl(isHoneycomb),
      noForm: new UntypedFormControl(!isStraight && !isHoneycomb),
    });
  }

  ngOnInit(): void {
    this.createForm();
    if (this.currentType === 2) {
      this.messageSubscription = this.messageService
        .getMessages()
        .subscribe((message: Message): void => {
          if (message.name === 'stackingChange' && message.data === true) {
            if (!this.loadArrangementForm.controls.straight.value) {
              this.loadArrangementForm.controls.honeycomb.setValue(true);
            }
            if (!this.loadArrangementForm.controls.honeycomb.value) {
              this.loadArrangementForm.controls.straight.setValue(true);
            } else {
              this.loadArrangementForm.controls.straight.setValue(false);
            }
            this.loadArrangementForm.controls.noForm.setValue(false);
          }
          if (message.name === 'stackingChange' && message.data === false) {
            this.loadArrangementForm.controls.honeycomb.setValue(false);
            this.loadArrangementForm.controls.straight.setValue(false);
            this.loadArrangementForm.controls.noForm.setValue(true);
          }
        });
      this.cdr.detectChanges();
    }
  }

  public straightChange(event: Event): void {
    event.preventDefault();
    const valueToBeSent =
      this.loadArrangementForm.controls?.straight?.value &&
      !this.loadArrangementForm.controls?.honeyComb?.value
        ? 0
        : 1;
    this.loadArrangementForm.controls.straight.setValue(
      !this.loadArrangementForm.controls.straight.value,
    );
    this.loadArrangementForm.controls.honeycomb.setValue(false);
    this.loadArrangementForm.controls.noForm.setValue(false);
    this.loadArrangementChange.emit(valueToBeSent);
    this.messageService.sendMessage({ name: 'arrangementChange', data: valueToBeSent });
  }

  public noFormChange(event: Event): void {
    event.preventDefault();
    this.loadArrangementForm.controls.noForm.setValue(
      !this.loadArrangementForm.controls.noForm.value,
    );
    this.loadArrangementForm.controls.honeycomb.setValue(false);
    this.loadArrangementForm.controls.straight.setValue(false);
    this.loadArrangementChange.emit(0);
    this.messageService.sendMessage({ name: 'arrangementChange', data: 0 });
  }

  public honeycombChange(event: Event): void {
    event.preventDefault();
    const valueToBeSent =
      this.loadArrangementForm.controls?.honeycomb?.value &&
      !this.loadArrangementForm.controls?.straight?.value
        ? 0
        : 2;
    this.loadArrangementForm.controls.honeycomb.setValue(
      !this.loadArrangementForm.controls.honeycomb.value,
    );
    this.loadArrangementForm.controls.straight.setValue(false);
    this.loadArrangementForm.controls.noForm.setValue(false);
    this.loadArrangementChange.emit(valueToBeSent);
    this.messageService.sendMessage({ name: 'arrangementChange', data: valueToBeSent });
  }

  ngOnDestroy(): void {
    if (this.currentType === 2 && this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentType && changes.currentType.currentValue) {
      this.currentType = changes.currentType.currentValue;
    }
    if (
      (changes.currentType &&
        changes.currentType.currentValue === 2 &&
        changes.currentType.previousValue !== 2) ||
      (changes.currentType &&
        changes.currentType.currentValue === 1 &&
        changes.currentType.previousValue !== 1)
    ) {
      this.createForm();
    }
  }
}
